import React, { useState } from 'react';
import { List, Button, Tooltip, Space } from 'antd';
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { FileMetadata } from '@/types/models';
import { formatFileSize } from '@/utils/fileUtils';
import { formatDate } from '@/utils/date';
import FilePreview from './FilePreview';
import { useFiles } from '@/contexts/FileContext';
import { ListContainer, FileIcon } from './styles/FileList.styles';

interface FileListProps {
  tournamentId: number;
  canDelete?: boolean;
}

const FileList: React.FC<FileListProps> = ({ tournamentId, canDelete }) => {
  const { files, deleteFile } = useFiles();
  const [previewFile, setPreviewFile] = useState<FileMetadata | null>(null);

  const handleDelete = async (fileId: string | number) => {
    // Преобразуем fileId в string, если он number
    const fileIdStr = typeof fileId === 'number' ? String(fileId) : fileId;
    await deleteFile(tournamentId, fileIdStr);
  };

  const handleDownload = (file: FileMetadata) => {
    window.open(file.url, '_blank');
  };

  return (
    <ListContainer>
      <List
        dataSource={files}
        renderItem={(file) => (
          <List.Item>
            <List.Item.Meta
              avatar={<FileIcon />}
              title={file.name}
              description={`${formatFileSize(file.size)} • ${formatDate(file.createdAt)}`}
            />
            <Space>
              <Tooltip title="Предпросмотр">
                <Button
                  icon={<EyeOutlined />}
                  onClick={() => setPreviewFile(file)}
                />
              </Tooltip>
              <Tooltip title="Скачать">
                <Button
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(file)}
                />
              </Tooltip>
              {canDelete && (
                <Tooltip title="Удалить">
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(file.id)}
                  />
                </Tooltip>
              )}
            </Space>
          </List.Item>
        )}
      />
      {previewFile && (
        <FilePreview
          file={previewFile}
          visible={true}
          onClose={() => setPreviewFile(null)}
        />
      )}
    </ListContainer>
  );
};

export default FileList;  // Changed from export const FileList
